// Feature-detected modules: each one is only fetched when the page
// actually contains its markup, Vite emits them as separate chunks next to
// the entry (dist/chunks/, sitepackage Resources/Public/JavaScript/chunks/).
// The entry has to be loaded as a module script (type="module"), so the
// relative chunk paths resolve against the entry URL, not the page URL.
// Each module keeps its own readyState check, so a late import still runs
// its init right away.
const lazyModules: ReadonlyArray<{ selector: string; load: () => Promise<unknown> }> = [
  // Prism core plus five languages, only on pages with a code block
  { selector: 'code[class*="language-"]', load: () => import('./prism') },
  // Scrollytelling stage of the case stories
  { selector: '[data-story]', load: () => import('./case-story') },
  // Brick game easter egg behind the cursor pixel of the mark illustration
  { selector: '[data-th-game-door]', load: () => import('./brick-game') },
];

function loadLazyModules(): void {
  lazyModules.forEach(({ selector, load }) => {
    if (document.querySelector(selector)) {
      load().catch((error: unknown) => console.error('Loading a design-system module failed', error));
    }
  });
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', loadLazyModules) : loadLazyModules();
